import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { OkvedModel, SavePackageModel } from 'Pages/registratorCabinet'

export type OkvedsState = {
	allOkveds: OkvedModel[]
}

export const okvedsInitialState: OkvedsState = {
	allOkveds: null,
}

export namespace OkvedsNS {
	export type getAllOkveds = PayloadAction
	export type setAllOkveds = PayloadAction<OkvedModel[]>
	export type clearOkveds = PayloadAction
	export type createOkvedPackage = PayloadAction<SavePackageModel>
}

export const okvedsSlice = createSlice({
	name: 'okveds',
	initialState: okvedsInitialState,
	reducers: {
		getAll: (state, action: OkvedsNS.getAllOkveds) => {},
		setAll: (state, action: OkvedsNS.setAllOkveds) => {
			state.allOkveds = action.payload
		},
		clearAll: (state, action: OkvedsNS.clearOkveds) => {
			state.allOkveds = []
		},
		createOne: (state, action: OkvedsNS.createOkvedPackage) => {},
	},
})
